export default __webpack_public_path__ + "static/media/study.1797d6f7.svg";